export const getEmailErrorMessage = (
    showErrors: boolean,
    emailError: boolean,
    emailValidationError: boolean
) => {
    if (!showErrors) return
    if (emailError) return "Укажите почту."
    if (emailValidationError) return "Проверьте правильность написания почты."
}

export const getNameErrorMessage = (
    showErrors: boolean,
    nameError: boolean,
    nameValidationError: boolean
) => {
    if (!showErrors) return
    if (nameError) return "Укажите ваше имя."
    if (nameValidationError) return "Длина имени должна быть меньше 50-ти знаков."
}

export enum VERIFICATION_ERROR {
    PHONE_IS_NOT_ALLOWED = "phone_is_not_allowed",
    PHONE_EXISTS = "phone_exists",
    COMMON = "verification_error",
    EMAIL_EXISTS = "email_exists",
    EMAIL_NOT_EXISTS = "email_not_exists",
    TOKEN_NOT_FOUND = "token_not_found",
    CODE_NOT_FOUND = "code_not_found",
    SOURCE_ERROR = "source_error",
    TOO_EARLY = "too_early",
    ACTION_NOT_FOUND = "action_not_found",
}

export const VERIFICATION_ERROR_MAP: Record<VERIFICATION_ERROR, string> = {
    [VERIFICATION_ERROR.PHONE_IS_NOT_ALLOWED]: "Номер телефона не разрешен.",
    [VERIFICATION_ERROR.PHONE_EXISTS]: "Номер телефона уже зарегистрирован.",
    [VERIFICATION_ERROR.COMMON]: "Ошибка при верификации.",
    [VERIFICATION_ERROR.EMAIL_EXISTS]:
        "Пользователь с таким адресом электронной почты уже существует.",
    [VERIFICATION_ERROR.EMAIL_NOT_EXISTS]:
        "У нас нет такого адреса почты. Возможно, вы еще не зарегистрировались.",
    [VERIFICATION_ERROR.TOKEN_NOT_FOUND]: "Неверный код.",
    [VERIFICATION_ERROR.CODE_NOT_FOUND]: "Неверный код.",
    [VERIFICATION_ERROR.SOURCE_ERROR]: "Тип контакта неизвестен.",
    [VERIFICATION_ERROR.TOO_EARLY]: "Слишком частый запрос.",
    [VERIFICATION_ERROR.ACTION_NOT_FOUND]: "Тип действия не найден.",
}
